import React from 'react';
import { TextField } from '@mui/material';
import { GOOGLE_API_KEY } from 'constants/config';
import { usePlacesWidget } from 'react-google-autocomplete';
import { collectGoogleQueryData } from 'utils/soldOut';

/**
 * Suggest-only address input. Google Places offers suggestions while typing,
 * and picking one fills the structured fields via `onPlaceSelected`. Unlike the
 * shared GooglAutocomplete, this NEVER validates or requires a real Google
 * address — any custom text the user types is accepted as-is.
 */
export default function AddressAutocompleteInput({
  label,
  value,
  onChange = () => {},
  onPlaceSelected = () => {},
  placeholder,
  size = 'small',
  ...props
}) {
  const { ref } = usePlacesWidget({
    apiKey: GOOGLE_API_KEY,
    onPlaceSelected: (place) => {
      onPlaceSelected(collectGoogleQueryData(place));
    },
    options: {
      types: ['geocode'],
    },
  });

  return (
    <TextField
      inputRef={ref}
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      fullWidth
      size={size}
      InputLabelProps={{ shrink: true }}
      {...props}
    />
  );
}
